/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */

/* !!!!!!!!!!!!!!!!!!!!!! */

export enum PlanTemplateType {
  None = "none",

  CustomTemplate = "custom-template",
  Wizard = "wizard",

  FromScratch = "from-scratch",
  TravelTime = "travel-time",
  PartyTime = "party-time",
  HomeRenovation = "home-renovation",

  QuickstartDates = "quickstart-dates",
  QuickstartLocations = "quickstart-locations",
  QuickstartPoll = "quickstart-poll",
  QuickstartRsvp = "quickstart-rsvp",
  QuickstartExpenses = "quickstart-expenses",

  FlowAdventureParkVisit = "adventure-park-visit",
  FlowArtExhibition = "art-exhibition",
  FlowArtFestival = "art-festival",
  FlowArtWorkshop = "art-workshop",
  FlowBakingClass = "baking-class",
  FlowBakingCompetition = "baking-competition",
  FlowBakingWithKids = "baking-with-kids",
  FlowBarbecueParty = "barbecue-party",
  FlowBeachDay = "beach-day",
  FlowBoardGameCafeVisit = "board-game-cafe-visit",
  FlowBoardGameNight = "board-game-night",
  FlowBoardGameTournament = "board-game-tournament",
  FlowBookClub = "book-club",
  FlowBookExchange = "book-exchange",
  FlowBookbindingWorkshop = "bookbinding-workshop",
  FlowBreweryTour = "brewery-tour",
  FlowCampingTrip = "camping-trip",
  FlowCharityRun = "charity-run",
  FlowCodingBootcamp = "coding-bootcamp",
  FlowCoffeeTasting = "coffee-tasting",
  FlowConcertNight = "concert-night",
  FlowCookingChallenge = "cooking-challenge",
  FlowCookingClass = "cooking-class",
  FlowCookingCompetition = "cooking-competition",
  FlowCookingForACause = "cooking-for-a-cause",
  FlowCookingWithKids = "cooking-with-kids",
  FlowCraftBeerBreweryTour = "craft-beer-brewery-tour",
  FlowCraftWorkshop = "craft-workshop",
  FlowCulinaryClass = "culinary-class",
  FlowCulturalExperience = "cultural-experience",
  FlowCulturalFestival = "cultural-festival",
  FlowDIYProject = "diy-project",
  FlowDanceParty = "dance-party",
  FlowDinnerParty = "dinner-party",
  FlowEatOut = "eat-out",
  FlowEscapeRoom = "escape-room",
  FlowFamilyArtDay = "family-art-day",
  FlowFamilyGameDay = "family-game-day",
  FlowFamilyGameNight = "family-game-night",
  FlowFamilyHealthDay = "family-health-day",
  FlowFamilyMovieNight = "family-movie-night",
  FlowFamilySportsDay = "family-sports-day",
  FlowFamilyWellnessRetreat = "family-wellness-retreat",
  FlowFarmersMarket = "farmers-market",
  FlowFashionDesignWorkshop = "fashion-design-workshop",
  FlowFashionShow = "fashion-show",
  FlowFestivalTrip = "festival-trip",
  FlowFitnessChallenge = "fitness-challenge",
  FlowFitnessRetreat = "fitness-retreat",
  FlowFitnessWorkshop = "fitness-workshop",
  FlowFoodTruckEvent = "food-truck-event",
  FlowFunRunEvent = "fun-run-event",
  FlowGameDevelopmentWorkshop = "game-development-workshop",
  FlowGameShow = "game-show",
  FlowGameShowNight = "game-show-night",
  FlowGardenParty = "garden-party",
  FlowGroupCookingNight = "group-cooking-night",
  FlowGroupFitnessChallenge = "group-fitness-challenge",
  FlowGroupMeditation = "group-meditation",
  FlowGroupMeditationDay = "group-meditation-day",
  FlowHerbalWorkshop = "herbal-workshop",
  FlowHikingTrip = "hiking-trip",
  FlowHolidayParty = "holiday-party",
  FlowHomeImprovementProject = "home-improvement-project",
  FlowIceCreamSocial = "ice-cream-social",
  FlowIceSkating = "ice-skating",
  FlowKaraokeNight = "karaoke-night",
  FlowLanguageExchange = "language-exchange",
  FlowMindfulnessWorkshop = "mindfulness-workshop",
  FlowMovieMarathon = "movie-marathon",
  FlowMuralPaintingWorkshop = "mural-painting-workshop",
  FlowMurderMysteryParty = "murder-mystery-party",
  FlowMusicFestival = "music-festival",
  FlowMusicNight = "music-night",
  FlowMusicProductionWorkshop = "music-production-workshop",
  FlowNatureExploration = "nature-exploration",
  FlowNaturePhotography = "nature-photography",
  FlowNatureWalk = "nature-walk",
  FlowNetworkingEvent = "networking-event",
  FlowOutdoorAdventure = "outdoor-adventure",
  FlowOutdoorAdventureRetreat = "outdoor-adventure-retreat",
  FlowOutdoorFamilyDay = "outdoor-family-day",
  FlowOutdoorFitnessChallenge = "outdoor-fitness-challenge",
  FlowOutdoorHikingTrip = "outdoor-hiking-trip",
  FlowOutdoorMovieNight = "outdoor-movie-night",
  FlowOutdoorPaintingDay = "outdoor-painting-day",
  FlowOutdoorPicnic = "outdoor-picnic",
  FlowOutdoorSportsDay = "outdoor-sports-day",
  FlowOutdoorWellnessDay = "outdoor-wellness-day",
  FlowOutdoorYogaSession = "outdoor-yoga-session",
  FlowPaintNight = "paint-night",
  FlowPaintballGame = "paintball-game",
  FlowPersonalFinanceWorkshop = "personal-finance-workshop",
  FlowPetAdoptionEvent = "pet-adoption-event",
  FlowPhotographyExhibition = "photography-exhibition",
  FlowPhotographyWorkshop = "photography-workshop",
  FlowPicnic = "picnic",
  FlowPotluck = "potluck",
  FlowPotluckDinner = "potluck-dinner",
  FlowPotluckPicnic = "potluck-picnic",
  FlowPotteryClass = "pottery-class",
  FlowPotteryPaintingWorkshop = "pottery-painting-workshop",
  FlowPotteryWorkshop = "pottery-workshop",
  FlowQuiltingWorkshop = "quilting-workshop",
  FlowRoadTrip = "road-trip",
  FlowRockClimbingAdventure = "rock-climbing-adventure",
  FlowScavengerHunt = "scavenger-hunt",
  FlowSculptureWorkshop = "sculpture-workshop",
  FlowSelfCareWorkshop = "self-care-workshop",
  FlowSewingWorkshop = "sewing-workshop",
  FlowSkiTrip = "ski-trip",
  FlowSocialGathering = "social-gathering",
  FlowSocialMediaMarketingWorkshop = "social-media-marketing-workshop",
  FlowSpaDay = "spa-day",
  FlowSportsGame = "sports-game",
  FlowStorytellingNight = "storytelling-night",
  FlowSummerCamp = "summer-camp",
  FlowSustainableLivingWorkshop = "sustainable-living-workshop",
  FlowTechTalk = "tech-talk",
  FlowTravel = "travel-planner",
  FlowTravelPlan = "travel-plan",
  FlowTriviaGame = "trivia-game",
  FlowTriviaNightExtended = "trivia-night-extended",
  FlowVideoEditingWorkshop = "video-editing-workshop",
  FlowVirtualCulturalFestival = "virtual-cultural-festival",
  FlowVirtualGameNight = "virtual-game-night",
  FlowVirtualRealityExperience = "virtual-reality-experience",
  FlowVirtualWorkshop = "virtual-workshop",
  FlowWeekendAdventure = "weekend-adventure",
  FlowWeekendGetaway = "weekend-getaway",
  FlowWeekendRetreat = "weekend-retreat",
  FlowWellnessRetreat = "wellness-retreat",
  FlowWineAndPaintNight = "wine-and-paint-night",
  FlowWineTasting = "wine-tasting",
  FlowYogaClass = "yoga-class",
  FlowYogaRetreat = "yoga-retreat",
}
